import {
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
  } from "@mui/material";
  import { useRef, useState } from "react";
  import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
  import NocsRequests from "../../stores/NocsRequestsStore";
  import General from "../../stores/GeneralStore";
import CloseIcon from "../../assets/CloseIcon.svg";
import { validateDate } from "@mui/x-date-pickers/internals";
import { observer } from "mobx-react";
import User from "../../stores/UserStore";
import { useNavigate } from "react-router-dom";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
  interface Obj {
    [key: string]: string;
  }
  
  interface Props {
    closeModal:any;
  }
  
  const InsideModal = ({ closeModal}: Props) => {
    const ColorAss = General?.ColorAss;
    const contrast=General?.contrast;
    const unaigate=useNavigate()
    // alert(General?.codeLabels['cm_msg_92000_2800']?.label)
    return (
      <div
        style={{
          width:General?.isLargeScreen? "60%":"100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          margin: "auto",
          direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",
        }}
      >
         <div
          style={{
            // height: '20%',
            width: "100%",
            justifyContent: "space-between",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background: "#101e8e",
            display: "flex",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: contrast?.contrastColor ? contrast?.contrastColor :"#fff", justifySelf: "flex-start" }}>
          { General?.codeLabels["cm_invalid_parcel"]?.label?General?.codeLabels["cm_invalid_parcel"]?.label:"Invalid Parcel Number"}
          </h1>
          <img src={CloseIcon} alt="" onClick={closeModal} />
        </div>
       <div style={{padding:'1rem'}}>
       <span style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
       {User?.profile?.personId? General?.codeLabels['cm_msg_92000_2800']?.label?General?.codeLabels['cm_msg_92000_2800']?.label:"Parcel Number Entered Is Inside Network":General?.codeLabels['cm_enterappointmentreferencenumber']?.label?General?.codeLabels['cm_enterappointmentreferencenumber']?.label:"The entered plot is inside network. Please login / register to proceed with NOC application"}
            </span>
            <br />
          
        <div style={{width:'60%',display:"flex",justifyContent:'space-between'}}>
        <ButtonSecondary
          onClick={closeModal}
          style={{
            background: contrast?.contrastColor
            ? contrast?.contrastColor
            : ColorAss || "#101E8E",
          color: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
            height: "3.5rem",
            width: "12.5rem",
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            marginTop:'2rem'
          }}
        >
          {General?.codeLabels["cm_close"]?.label !== undefined ? General?.codeLabels["cm_close"]?.label : "Close"}
        </ButtonSecondary>
  
       {!User?.profile?.personId&& <ButtonSecondary
          onClick={()=>unaigate('/dashboard')}
          style={{
            background: contrast?.contrastColor
            ? contrast?.contrastColor
            : ColorAss || "#101E8E",
          color: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
            height: "3.5rem",
            width: "12.5rem",
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            marginTop:'2rem'
          }}
        >
        {General?.codeLabels['cm_login']?.label}
        </ButtonSecondary>}
        </div>
        </div>
       </div>
    );
  };
  
  export default observer(InsideModal);
  